"use client"

import React from "react"
import { useSearchParams } from "next/navigation"

import { cn } from "@/lib/utils"
import { Chip } from "@/components/ui/atoms"

interface IChipFilterListResolverProps {
  list: Array<{
    codename: string
    label: string
  }>
  onFilterChange: (newFilter: string | null) => void
}

const ChipFilterListResolver = ({
  list,
  onFilterChange,
}: IChipFilterListResolverProps) => {
  const searchParams = useSearchParams()
  const selectedTagLabel = searchParams.get("filter")

  const handleTagClick = (codename: string) => () => {
    const newFilter = selectedTagLabel === codename ? null : codename
    onFilterChange(newFilter)
  }

  return (
    <section className="chip-filter-list container">
      {list.map((filter) => {
        const isActive = filter.codename === selectedTagLabel
        const selectedModifier = isActive ? "chip--active" : ""

        return (
          <Chip
            key={filter.codename}
            title={filter.label}
            taglabel={filter.codename}
            className={cn("w-auto", selectedModifier)}
            onClick={handleTagClick(filter.codename)}
          />
        )
      })}
    </section>
  )
}

export { ChipFilterListResolver, type IChipFilterListResolverProps }
